import { createSlice } from '@reduxjs/toolkit';

type cartFormType = {
  cart: any;
};

const initialState: cartFormType = {
  cart: null,
};

const cart = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCart(state, action) {
      const { payload } = action;
      state.cart = payload;
    },
    clearCart(state) {
      state.cart = initialState.cart;
    },
  },
});

export const { setCart, clearCart } = cart.actions;

export default cart.reducer;
